import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { baseStyles } from '../styles/shared.js';

// ---------------------------------------------------------------------------
// <sysml-domain-loader> — Loading spinner / skeleton shown while data loads
// ---------------------------------------------------------------------------

@customElement('sysml-domain-loader')
export class SysmlDomainLoader extends LitElement {
  static override styles = [
    baseStyles,
    css`
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        min-height: 300px;
      }
      .loader {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--r5-space-3);
        color: var(--r5-text-muted);
      }
      ark-spinner {
        --spinner-size: 32px;
      }
    `,
  ];

  override render() {
    return html`
      <div class="loader">
        <ark-spinner></ark-spinner>
        <span>Loading SysML workspace...</span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sysml-domain-loader': SysmlDomainLoader;
  }
}
